import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Globe, Menu, X, ChevronDown, User, LogOut, Wallet, IdCard, CreditCard } from 'lucide-react';
import '../../../../../styles/components/navbar-client.scss';
import i18n from '../../../../../i18n';
import { MzadcomLogoW } from '../../../../common/icons';
import { getLoggedUser } from '../../../../../state/user';
import { Clock } from '../../../../helpers/clock';

const user = getLoggedUser();
const roles = {
    A: i18n.t('admin'),
    C: i18n.t('client'),
    CE: i18n.t('ceo'),
    GM: i18n.t('gm'),
    F: i18n.t('finance'),
    HSE: i18n.t('hse'),
    O: i18n.t('operator'),
    M: i18n.t('manager'),
    PM: 'PM',
    OM: i18n.t('OM'),
    U: i18n.t('bidder'),
};
class NavbarClient extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scrolled: false,
            mobileOpen: false,
            langDropdownOpen: false,
            profileDropdownOpen: false,
        };
        this.navRef = React.createRef();
        this.langRef = React.createRef();
        this.profileRef = React.createRef();
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleScroll = () => {
        const scrolled = window.scrollY > 70;
        if (scrolled !== this.state.scrolled) {
            this.setState({ scrolled });
        }
    };

    handleClickOutside = (e) => {
        if (this.langRef.current && !this.langRef.current.contains(e.target)) {
            this.setState({ langDropdownOpen: false });
        }
        if (this.profileRef.current && !this.profileRef.current.contains(e.target)) {
            this.setState({ profileDropdownOpen: false });
        }
    };

    toggleMobile = () => {
        this.setState((prev) => ({ mobileOpen: !prev.mobileOpen }));
    };

    closeMobile = () => {
        this.setState({ mobileOpen: false });
    };

    toggleLangDropdown = () => {
        this.setState((prev) => ({
            langDropdownOpen: !prev.langDropdownOpen,
            profileDropdownOpen: false,
        }));
    };

    toggleProfileDropdown = () => {
        this.setState((prev) => ({
            profileDropdownOpen: !prev.profileDropdownOpen,
            langDropdownOpen: false,
        }));
    };

    switchLanguage = (lang) => {
        i18n.changeLanguage(lang);
        document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.lang = lang;
        this.setState({ langDropdownOpen: false });
        window.location.reload();
    };

    handleLogout = () => {
        localStorage.removeItem('is_logged_in');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/';
    };
    getDashboardRoute = () => {
        switch (user?.role) {
            case 'CE':
                return '/management';
            case 'C':
                return '/client-dashboard';
            case 'O':
                return '/delivery-site-list';
            default:
                return '/dashboard';
        }
    };

    render() {
        const current_lng = localStorage.getItem('I18N_LANGUAGE') || 'en';

        const { scrolled, mobileOpen, langDropdownOpen, profileDropdownOpen } = this.state;
        const { is_logged_in, wallet_amount, homePage, due_amount, is_loading } = this.props;
        const isArabic = i18n.language.startsWith('ar');
        const currentLang = isArabic ? 'العربية' : 'EN';

        const NAV_LINKS = [
            { to: '/', label: i18n.t('home') || 'Home Page', exact: true },
            ...(is_logged_in ? [{ to: '/my-auctions', label: i18n.t('my_auctions') || 'My Auctions', exact: true }] : []),
            { to: '/about', label: i18n.t('aboutus') },
            { to: '/auc-calendar', label: i18n.t('auction_calendar') },
            { to: '/contact', label: i18n.t('contactus') },

        ];

        return (
            <div
                ref={this.navRef}
                className={`mzn-header ${this.props.homePage ? (scrolled ? 'mzn-header--scrolled' : '') : 'mzn-header--scrolled mzn-header--sticky'}`}
            >
                <nav className="mzn-nav">
                    {/* ── Logo ── */}


                    <Link to="/" className="mzn-nav__logo">
                        {/* <img
                            src={process.env.PUBLIC_URL + '/assets/images/logo-org-white.png'}
                            alt="Mzadcom Logo"
                            className="prof-navbar__logo-img"
                        /> */}
                        <MzadcomLogoW />
                    </Link>

                    {/* ── Desktop Links ── */}
                    <ul className="mzn-nav__links">
                        {NAV_LINKS.map((link) => (
                            <li key={link.to} className="mzn-nav__item">
                                <NavLink
                                    to={link.to}
                                    end={link.exact}
                                    className={({ isActive }) =>
                                        `mzn-nav__link ${isActive ? 'mzn-nav__link--active' : ''}`
                                    }
                                >
                                    {link.label}
                                </NavLink>
                            </li>
                        ))}
                    </ul>

                    <div className="prof-navbar__clock">
                        <img
                            src={
                                process.env.PUBLIC_URL +
                                `/assets/images/flags/ar.svg`
                            }

                            className="prof-navbar__flag"
                        />
                        <Clock lang={current_lng} />
                    </div>

                    {/* ── Right Actions ── */}
                    <div className="mzn-nav__actions">
                        {/* Language Switcher */}
                        <div className="mzn-nav__lang" ref={this.langRef}>
                            <button
                                className="mzn-nav__lang-btn"
                                onClick={this.toggleLangDropdown}
                                aria-label="Switch language"
                            >
                                <Globe size={18} />
                            </button>

                            {langDropdownOpen && (
                                <div className="mzn-nav__dropdown mzn-nav__dropdown--lang">
                                    <button
                                        className={`mzn-nav__dropdown-item ${!isArabic ? 'mzn-nav__dropdown-item--active' : ''}`}
                                        onClick={() => this.switchLanguage('en')}
                                    >
                                        English
                                    </button>
                                    <button
                                        className={`mzn-nav__dropdown-item ${isArabic ? 'mzn-nav__dropdown-item--active' : ''}`}
                                        onClick={() => this.switchLanguage('ar')}
                                    >
                                        العربية
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* Auth / Profile */}
                        {is_logged_in ? (
                            <div className="mzn-nav__profile" ref={this.profileRef}>
                                <button
                                    className="mzn-nav__profile-btn"
                                    onClick={this.toggleProfileDropdown}
                                >
                                    <User size={16} />
                                    <ChevronDown size={14} className={`mzn-nav__chevron ${profileDropdownOpen ? 'mzn-nav__chevron--open' : ''}`} />
                                </button>

                                {profileDropdownOpen && (
                                    <div className="mzn-nav__dropdown mzn-nav__dropdown--profile">
                                        <span className="mzn-nav__dropdown-item">
                                            <IdCard size={18} />
                                            <div>

                                                <span className="prof-navbar__dropdown-label">{i18n.t('role')}</span>
                                                <div>{user?.role ? roles[user.role] : 'Guest'}</div>
                                            </div>
                                        </span>



                                        <Link
                                            to={this.getDashboardRoute()}
                                            className="mzn-nav__dropdown-item"
                                            onClick={() => this.setState({ profileDropdownOpen: false })}
                                        >
                                            <User size={14} />
                                            {i18n.t('dashboard') || 'Dashboard'}
                                        </Link>
                                        <Link
                                            to="/wallet"
                                            className="mzn-nav__dropdown-item"
                                            onClick={() => this.setState({ profileDropdownOpen: false })}
                                        >
                                            <Wallet size={14} />
                                            {i18n.t('wallet') || 'Wallet'}
                                            {wallet_amount !== undefined && (
                                                <span className="mzn-nav__wallet-badge">
                                                    {Number(wallet_amount).toFixed(2)}
                                                </span>
                                            )}
                                        </Link>

                                        {user?.role === 'U' && due_amount > 0 && (
                                            <Link
                                                to="/mzadcom-payment"
                                                className="mzn-nav__dropdown-item"
                                                onClick={this.toggleUserDropdown}
                                            >
                                                <CreditCard size={18} />
                                                {i18n.t('mzadcom_due')}
                                                <span className="mzn-nav__wallet-badget">
                                                    {Number(due_amount).toFixed(2)}
                                                </span>
                                            </Link>
                                        )}
                                        <div className="mzn-nav__dropdown-divider" />
                                        <button
                                            className="mzn-nav__dropdown-item mzn-nav__dropdown-item--danger"
                                            onClick={this.handleLogout}
                                        >
                                            <LogOut size={14} />
                                            {i18n.t('logout') || 'Sign out'}
                                        </button>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <Link to="/login" className="mzn-nav__signin">
                                {i18n.t('sign_in') || 'Sign in'}
                            </Link>
                        )}

                        {/* Mobile Toggle */}
                        <button
                            className="mzn-nav__burger"
                            onClick={this.toggleMobile}
                            aria-label="Toggle menu"
                        >
                            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
                        </button>
                    </div>
                </nav>

                {/* ── Mobile Menu ── */}
                {/* ── Mobile Overlay ── */}
                {mobileOpen && (
                    <div className="mzn-overlay" onClick={this.closeMobile} />
                )}

                {/* ── Mobile Drawer ── */}
                <div className={`mzn-drawer ${mobileOpen ? 'mzn-drawer--open' : ''}`}>
                    <div className="mzn-drawer__header">
                        <span className="mzn-drawer__title">{i18n.t('menu') || 'Menu'}</span>
                        <button className="mzn-drawer__close" onClick={this.closeMobile}>
                            <X size={22} />
                        </button>
                    </div>

                    {is_logged_in && (
                        <div className="mzn-drawer__user">
                            <div className="mzn-drawer__avatar">
                                {(user?.name || 'G').charAt(0).toUpperCase()}
                            </div>
                            <div className="mzn-drawer__user-info">
                                <span className="mzn-drawer__user-name">{user?.name || i18n.t('guest')}</span>
                                <span className="mzn-drawer__user-role">{user?.role ? roles[user.role] : 'Guest'}</span>
                            </div>
                        </div>
                    )}

                    <ul className="mzn-drawer__nav">
                        {NAV_LINKS.map((link) => (
                            <li key={link.to}>
                                <NavLink
                                    to={link.to}
                                    end={link.exact}
                                    className={({ isActive }) =>
                                        `mzn-drawer__link ${isActive ? 'mzn-drawer__link--active' : ''}`
                                    }
                                    onClick={this.closeMobile}
                                >
                                    {link.label}
                                </NavLink>
                            </li>
                        ))}
                    </ul>

                    <div className="prof-navbar__clock">
                        <Clock lang={current_lng} />
                    </div>

                    {is_logged_in ? (
                        <div className="mzn-drawer__actions">
                            <Link to={this.getDashboardRoute()} className="mzn-drawer__btn" onClick={this.closeMobile}>
                                <User size={18} />
                                <span>{i18n.t('dashboard') || 'Dashboard'}</span>
                            </Link>
                            <Link to="/wallet" className="mzn-drawer__btn mzn-drawer__btn--wallet" onClick={this.closeMobile}>
                                <Wallet size={18} />
                                <div className="mzn-drawer__btn-info">
                                    <span className="mzn-drawer__btn-label">{i18n.t('wallet')}</span>
                                    <span className="mzn-drawer__btn-value">{i18n.t('omr')} {Number(wallet_amount || 0).toFixed(2)}</span>
                                </div>
                            </Link>
                            <button className="mzn-drawer__btn mzn-drawer__btn--danger" onClick={this.handleLogout}>
                                <LogOut size={18} />
                                <span>{i18n.t('logout') || 'Sign out'}</span>
                            </button>
                        </div>
                    ) : (
                        <div className="mzn-drawer__actions">
                            <Link to="/login" className="mzn-drawer__signin" onClick={this.closeMobile}>
                                {i18n.t('sign_in') || 'Sign in'}
                            </Link>
                            <Link to="/register" className="mzn-drawer__register" onClick={this.closeMobile}>
                                {i18n.t('registration') || 'Register'}
                            </Link>
                        </div>
                    )}

                    <div className="mzn-drawer__footer">
                        <div className="mzn-drawer__lang-row">
                            <button
                                className={`mzn-drawer__lang ${!isArabic ? 'mzn-drawer__lang--active' : ''}`}
                                onClick={() => this.switchLanguage('en')}
                            >
                                English
                            </button>
                            <button
                                className={`mzn-drawer__lang ${isArabic ? 'mzn-drawer__lang--active' : ''}`}
                                onClick={() => this.switchLanguage('ar')}
                            >
                                العربية
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NavbarClient;